import type { GetTweets200PageAllOfThreeContentItemReferencedTweetTweetAuthor } from './getTweets200PageAllOfThreeContentItemReferencedTweetTweetAuthor';
import type { GetTweets200PageAllOfThreeContentItemReferencedTweetTweetBasicInfo } from './getTweets200PageAllOfThreeContentItemReferencedTweetTweetBasicInfo';
import type { GetTweets200PageAllOfThreeContentItemReferencedTweetTweetEngagement } from './getTweets200PageAllOfThreeContentItemReferencedTweetTweetEngagement';

/**
 * 참조된 트윗 요약 정보 (순환 참조 방지)
 */
export type GetTweets200PageAllOfThreeContentItemReferencedTweetTweet = {
  /** 트윗 작성자 정보 */
  author?: GetTweets200PageAllOfThreeContentItemReferencedTweetTweetAuthor;
  basicInfo?: GetTweets200PageAllOfThreeContentItemReferencedTweetTweetBasicInfo;
  engagement?: GetTweets200PageAllOfThreeContentItemReferencedTweetTweetEngagement;
};
